// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";
import { Navigate } from "react-router";

import { ENV } from "../../../ENV";

function ShowProtectedRoutes({ children }) {
  // If the user is a local user, redirect them to the home page
  if (ENV.USE_LOCAL_ACCOUNTS) {
    return <Navigate to="/" replace={true} />;
  }

  return children;
}

export default ShowProtectedRoutes;
